import { z } from 'zod';
import { JsonValueZod } from './json.value.zod';

export const ValidatorRefZod = z.object({
  type: z.string().min(1),
  config: z.record(z.string(), JsonValueZod).optional(),
  message: z.string().optional(),
  enabled: z.boolean().optional(),
}).strict();

export type ValidatorRef = z.infer<typeof ValidatorRefZod>;
